import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private identityApi = '';
  private customerApi = '';

  constructor(protected http: HttpClient) {
    this.identityApi = environment.identityApiUrl;
    this.customerApi = environment.customerApiUrl;
  }

  userDetail$: Observable<any> = this.http.get<any>(environment.customerApiUrl + '/customer/get-account-detail').pipe(
    shareReplay(1),
  );

  getAccountInfo(): Observable<any> {
    return this.http.get<any>(`${this.identityApi}/account/account-info`);
  }

  updateUser(user: any): Observable<any> {
    return this.http.post<any>(`${this.identityApi}/account/update-account`, user);
  }

  updateUserDetail(userDetail: any): Observable<any> {
    return this.http.post<any>(`${this.customerApi}/customer/update-account-detail`, userDetail);
  }

  getUserDetail(forceUpdate = false): Observable<any> {
    if (forceUpdate) {
      this.userDetail$ = this.http.get<any>(environment.customerApiUrl + '/customer/get-account-detail').pipe(
        shareReplay(1),
      );
    }
    return this.userDetail$;
  }
}


